export function fractionScore(value) {
  if (!String(value ?? '').trim()) return { score: '', error: '' };
  const match = String(value).trim().match(/^(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)$/);
  if (!match) return { score: '', error: 'Enter earned/possible points, such as 2/3 or 10/15.' };
  const earned = Number(match[1]);
  const possible = Number(match[2]);
  if (!Number.isFinite(earned) || !Number.isFinite(possible) || possible <= 0) {
    return { score: '', error: 'Possible points must be greater than zero and both values must be finite.' };
  }
  // The existing data-point API stores whole-number percentages.
  const percentage = Math.round((earned / possible) * 100);
  if (!Number.isSafeInteger(percentage) || percentage > 2147483647) {
    return { score: '', error: 'The calculated percentage is too large. Check the points entered.' };
  }
  return { score: String(percentage), error: '' };
}
